<template>
  <div>
    <div class="learn_all">
      <div
        class="learn_item"
        v-for="(item, index) in LearnList"
        :key="index"
        @click.stop="togoodsdetail(item.id)"
      >
        <div class="top_img">
          <img :src="item.cover" alt="" />
        </div>
        <div class="titles">{{ item.title }}</div>
        <div class="box">
          <div class="buttons" v-if="item.type == 'courseware'">课件</div>
          <div class="buttons" v-if="item.type == 'ebook'">电子书</div>
          <div class="buttons" v-if="item.type == 'looseleafOrtextbook'">
            活页
          </div>
          <div class="buttons" v-if="item.type == 'paper'">试卷</div>
          <div class="buttons" v-if="item.type == 'cource'">课程</div>
          <div class="jd" v-if="item.type == 'ebook'">
            已读{{ item.schedule ? item.schedule : 0 }}%
          </div>
        </div>
        <div class="learn_box">
          <div class="minutes" v-if="item.type == 'ebook'">
            学习{{ toHoursAndMinutes(item.learningTime) }}
          </div>
          <div class="minutes" v-else></div>
          <div class="minutes_img" @click.stop="openFlooter(index)">
            <img src="../../../assets/icon/more.png" alt="" />
          </div>
        </div>
        <div v-if="index == learnstate">
          <div
            class="fixed_box"
            v-if="
              item.type == 'ebook' ||
              item.type == 'courseware' ||
              item.type == 'looseleafOrtextbook'
            "
          >
            <div class="items">
              <img src="../../../assets/icon/yellowsq.png" alt="" /><span
                >书签:{{ item.countinfo.bookmark }}</span
              >
            </div>
            <div class="items">
              <img src="../../../assets/icon/greenb.png" alt="" /><span
                >笔记:{{ item.countinfo.note }}</span
              >
            </div>
            <div class="items">
              <img src="../../../assets/icon/bluehb.png" alt="" /><span
                >划线:{{ item.countinfo.lineation }}</span
              >
            </div>
          </div>
          <div class="fixed_box" v-if="item.type == 'paper'">
            <div class="items">
              <img src="../../../assets/icon/bluebj.png" alt="" /><span
                >答题次数:{{
                  item.countinfo.goodPaperRecord
                    ? item.countinfo.questionRecord
                    : 0
                }}</span
              >
            </div>
            <div class="items">
              <img src="../../../assets/icon/greenhb.png" alt="" /><span
                >答题数量:{{
                  item.countinfo.questionRecord
                    ? item.countinfo.questionRecord
                    : 0
                }}</span
              >
            </div>
          </div>
          <div class="fixed_box sc" v-if="item.type == 'cource'">
            <div class="items">
              <img src="../../../assets/icon/redtime.png" alt="" /><span
                >看课时长:{{
                  item.countinfo.lookRecord ? item.countinfo.lookRecord : 0
                }}分钟</span
              >
            </div>
            <div class="items">
              <img src="../../../assets/icon/greenhb.png" alt="" /><span
                >答题数量:{{ item.countinfo.questionRecord }}6</span
              >
            </div>
          </div>
        </div>
        <div class="nearly" v-if="index == 0">上次阅读</div>
      </div>
    </div>
    <div class="pages_box">
      <pages
        :total="Learntotal"
        :pageNum="learnPageNum"
        :pageSize="learnPageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pages>
    </div>
    <noData v-if="Learntotal == 0"></noData>
  </div>
</template>
<script>
import noData from "@/components/noData.vue";
import {
  queryLearningRecord,
  queryAnswerNum,
  queryLearningRecordByInfo,
} from "@/api/user/learning.js";
import pages from "@/components/pages.vue";
export default {
  components: { noData, pages },
  data() {
    return {
      // total: 0,
      learnPageNum: 1,
      learnPageSize: 10,
      LearnList: [],
      Learntotal: 0,
      learnstate: 0,
    };
  },
  computed: {},
  created() {
    this.getMyLearnList();
  },
  mounted() {},
  methods: {
    //获取我的书架学习记录列表
    getMyLearnList() {
      queryLearningRecord({
        pageNum: this.learnPageNum,
        pageSize: this.learnPageSize,
      }).then((res) => {
        let list = res.rows;
        list.map((item, index) => {
          this.$set(item, "countinfo", {});
          if (
            item.type == "ebook" ||
            item.type == "courseware" ||
            item.type == "looseleafOrtextbook"
          ) {
            this.getBookMartnum(
              item.id,
              index + (this.learnPageNum - 1) * this.learnPageSize
            );
          } else {
            this.getExamNumber(
              item.id,
              index + (this.learnPageNum - 1) * this.learnPageSize
            );
          }
        });
        // this.LearnList = this.LearnList.concat(list);
        this.LearnList = list;
        this.Learntotal = res.total;
      });
    },
    getExamNumber(data, index) {
      queryAnswerNum({
        goodsId: data,
      }).then((res) => {
        this.LearnList[index].countinfo = res.data;
      });
    },
    getBookMartnum(data, index) {
      queryLearningRecordByInfo({
        goodsId: data,
      }).then((res) => {
        this.LearnList[index].countinfo = res.data;
      });
    },
    //分钟数转时分
    toHoursAndMinutes(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return hours + "小时" + minutes + "分钟";
    },
    handleSizeChange(val) {
      this.learnPageSize = val;
      this.LearnList = [];
      this.getMyLearnList();
    },
    handleCurrentChange(val) {
      this.learnPageNum = val;
      this.LearnList = [];
      this.getMyLearnList();
    },
    // 点击展开底部
    openFlooter(index) {
      if (index == this.learnstate) {
        this.learnstate = null;
      } else {
        this.learnstate = index;
      }
    },
    togoodsdetail(id) {
      this.$router.push({
        path: "/bookstore/bookstoreDetail",
        query: {
          goodsId: id,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.learn_all {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-wrap: wrap;
  padding: 41px 40px 0 40px;
  .learn_item {
    margin-bottom: 30px;
    margin-right: 60px;
    position: relative;
    width: 150px;
    .top_img {
      border-radius: 16px;
      border: 1px solid #fbfbfb;
      background-color: #fbfbfb;
      width: 150px;
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .titles {
      margin-top: 19px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 151px;
      height: 14px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 14px;
    }
    .box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .buttons {
        width: 60px;
        height: 24px;
        background: #f9fdff;
        border: 1px solid #0081ce;
        border-radius: 6px;
        text-align: center;
        line-height: 24px;
        text-align: center;
        font-size: 13px;
        font-family: PingFang SC;
        color: #0081ce;
      }
      .jd {
        font-size: 12px;
        font-family: PingFang SC;
        color: #999999;
      }
    }
    .learn_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .minutes {
        flex: 1;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 9px;
      }
      .minutes_img {
        width: 15px;
        height: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .fixed_box {
      position: absolute;
      bottom: 10px;
      right: 14px;
      box-sizing: border-box;
      padding: 12px 10px 12px 10px;
      background: #ffffff;
      box-shadow: 0px 0px 2px 2px #f0f0f0;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      .items {
        margin-bottom: 19px;
        display: flex;
        align-items: center;
        img {
          width: 13px;
          height: 13px;
        }
        span {
          margin-left: 12px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 9px;
        }
      }
      .items:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
    .sc {
      min-width: 160px;
      padding-right: 0;
      padding-left: 8px;
    }
    .nearly {
      position: absolute;
      top: 12px;
      left: 0;
      width: 54px;
      height: 24px;
      background: #000000;
      opacity: 0.5;
      border-radius: 0px 12px 12px 0px;
      font-size: 12px;
      font-family: PingFang SC;
      color: #ffffff;
      line-height: 24px;
      text-align: center;
    }
  }
  .learn_item:nth-child(5n) {
    margin-right: 0;
  }
}
.pages_box {
  display: flex;
  justify-content: flex-end;
  padding-right: 41px;
  padding-bottom: 41px;
}
</style>
